import { Link } from "react-router-dom";
import { BRAND } from "@/lib/site";
import useT from "@/i18n";

export const Logo = ({ testId = "brand-logo" }) => {
  const { t, lp } = useT();
  return (
  <Link to={lp("/")} className="tap flex items-center gap-3 shrink-0" data-testid={testId} aria-label={`${BRAND} ${t.nav.home}`}>
    <span
      className="w-9 h-9 rounded-xl flex items-center justify-center font-display font-black text-[#04121F] text-lg"
      style={{ background: "linear-gradient(160deg,#3FD5FF,#0095D6)", boxShadow: "0 6px 20px -6px rgba(0,191,255,.7)" }}
      aria-hidden="true"
    >
      N
    </span>
    <span className="flex flex-col leading-none">
      <span className="font-display font-bold text-[15px] tracking-tight text-white">{BRAND}</span>
      <span className="text-[9px] tracking-[0.3em] text-[#7DDCFF] mt-1 uppercase">{t.nav.officialApk}</span>
    </span>
  </Link>
  );
};
